<!--  -->
<template>
  <div>
    <div>
      <el-input
        v-model="adqAdvertListParams.keyword"
        clearable
        style="width:240px;margin-right:10px"
        placeholder="请输入账号ID/账号名称"
      />
      <el-button
        type="primary"
        style="margin-left:10px"
        icon="el-icon-search"
        @click="sraw"
      >搜索</el-button>
      <el-button
        type="info"
        icon="el-icon-refresh"
        @click="awered"
      >重置</el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="adqAdvertList"
      highlight-current-row
      :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
      class="border-gray"
      fit
      style="width: 100%; justify-content: space-between;margin-top:20px"
    >
      <el-table-column
        prop="advertiser_name"
        label="广告主名称"
        align="center"
        width="250"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.advertiser_name"
          >
            {{ scope.row.advertiser_name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="agent_name"
        label="组织"
        align="center"
        width="250"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.agent_name"
          >
            {{ scope.row.agent_name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="company"
        label="公司"
        align="center"
        width="250"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.company"
          >
            {{ scope.row.company }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="account_id"
        label="账号ID"
        width="270"
        align="center"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.account_id"
          >
            {{ scope.row.account_id }}
          </p>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="first_industry_name"
        label="第一个工业名称"
        align="center"
        width="150"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.first_industry_name"
          >
            {{ scope.row.first_industry_name }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="second_industry_name"
        label="第二个工业名称"
        align="center"
        width="150"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.second_industry_name"
          >
            {{ scope.row.second_industry_name }}
          </p>
        </template>
      </el-table-column> -->
      <el-table-column
        prop="created_at"
        label="创建时间"
        align="center"
        width="250"
      >
        <template scope="scope">
          <p
            class="overflow"
            :title="scope.row.created_at"
          >
            {{ scope.row.created_at }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="操作"
        align="center"
        width="250"
        fixed="right"
      >
        <template scope="scope">
          <el-button
            type="primary"
            icon="el-icon-success"
            size="mini"
            @click="handlechooseTencentAdqAdver(scope.row)"
          >选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      :page-sizes="[10]"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
  </div>
</template>

<script>
import { getAccountList } from '@/api/massiveAdvertising/accountList.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
export default {
  components: { PaginationRight },
  data() {
    return {
      loading: false,
      adqAdvertList: [],
      total: null,
      adqAdvertListParams: {
        keyword: null,
        page: 1, // 当前页码
        page_size: 10 // 广告在系统中的状态
      }
    }
  },
  created() {},
  mounted() {},
  methods: {
    send() {
      this.fetchAdqAdvertList()
    },
    // 获取广告列表
    fetchAdqAdvertList() {
      this.loading = true
      getAccountList(this.adqAdvertListParams).then(res => {
        console.log('res:', res)
        this.adqAdvertList = res.data.list
        this.total = res.data.total
        this.loading = false
      })
    },
    handlechooseTencentAdqAdver(item) {
      console.log(item)
      this.$emit('callback', item)
    },
    fetchPageSize(e) {
      console.log('11', e)
      this.adqAdvertListParams.page_size = e
      this.fetchAdqAdvertList()
    },
    fetchCurrentPage(e) {
      console.log('22', e)
      this.adqAdvertListParams.page = e
      this.fetchAdqAdvertList()
    },
    sraw() {
      this.adqAdvertListParams.page = 1
      this.fetchAdqAdvertList()
    },
    awered() {
      this.adqAdvertListParams.page = 1
      this.adqAdvertListParams.keyword = null
      this.fetchAdqAdvertList()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
</style>
